<template>
  <BasePage :pageTitle="weekName" show-alt-menu show-footer :show-header="false">
    <div class="bg-primary hero-header">
      <div class="hero-row row p-4">
        <div class="col-3">
          <img :src="logoUrl" class="hero-logo" :class="{ 'hero-logo-invert': brandConfig.logoVariant === 'dark' }" alt=""/>
        </div>
        <div class="col p-1 ms-2">
          <span class="text-white h1">{{ weekName?.split(" | ")[0] || '' }}</span><br/>
          <span class="text-white"> {{ weekName?.split(" | ")[1] || '' }}</span>
        </div>
      </div>
    </div>
    <div class="container-xl py-3" style="margin-top: 20px">
      <div class="row g-3">
        <div v-for="(option, index) in options" :key="index" class="col-6 col-sm-4 col-lg-3">
          <div class="menu-card" @click="navigateTo(option.route)">
            <div class="icon-container">
              <component :is="option.icon" stroke="2.5" />
            </div>
            <div class="title-container">
              <h3>{{ option.title }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AlertModal
        :show="showAlert"
        title="Workshops"
        message="Workshops are managed under lessons for this week"
        type="info"
        confirm-text="OK"
        @close="showAlert = false"
        @confirm="showAlert = false"
        :showCancel=false
    />
  </BasePage>
</template>

<script setup>
import {useWeekStore} from "@/stores/week.js";
import {
  IconTicket,
  IconIdBadge,
  IconPlaneDeparture,
  IconBus,
  IconSchool,
  IconSnowboarding,
  IconKey
} from '@tabler/icons-vue';
import BasePage from "@/components/BasePage.vue";
import {useRouter} from "vue-router";
import {computed, ref} from "vue";
import AlertModal from "@/components/AlertModal.vue";
import squareLogo from '@brand/assets/square.png'
import brandConfig from '@brand/config.js'
const logoUrl = squareLogo
const router = useRouter();
const weekStore = useWeekStore();
const showAlert = ref(false)

const navigateTo = (route) => {
  if(route === 'registerWorkshop') {
    showAlert.value = true
  }
  router.push({ name: route });
};


const options = [
  { title: __DICT__.actionMenu.loadCoach, icon: IconBus, route: 'selectLoadCoach' },
  { title: __DICT__.actionMenu.loadTransfer, icon: IconPlaneDeparture, route: 'selectLoadTransfer' },
  { title: __DICT__.actionMenu.registerLesson, icon: IconSchool, route: 'registerLesson' },
  { title: __DICT__.actionMenu.registerWorkshop, icon: IconSnowboarding, route: 'registerWorkshop' },
  { title: __DICT__.actionMenu.eventAccreditation, icon: IconTicket, route: 'ticketing' },
  { title: __DICT__.actionMenu.liftPass, icon: IconIdBadge, route: 'liftPass' },
  { title: __DICT__.actionMenu.keyDist, icon: IconKey, route: 'keyDistSelect' },
]

const weekName = weekStore.weekName;

</script>

<!-- Menu card styles from shared _menu-cards.scss -->